import script from "./CountryClientsChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./CountryClientsChart.vue?vue&type=script&setup=true&lang=ts"

import "./CountryClientsChart.vue?vue&type=style&index=0&id=7d4e94fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d4e94fc"]])

export default __exports__